module.exports = __webpack_public_path__ + "img/tz.eb25a2de.svg";